import { mustBeFilled } from '../../libs/validators';

export const inputSocialSecurityConfig = {
  choices: [
    { label: 'Oui', value: 'Oui' },
    { label: 'Non', value: 'Non' },
  ],
  description:
    'Votre numéro de sécurité sociale est définitif si il commence par le chiffre 1 ou 2',
  label: 'Avez-vous un numéro de sécurité sociale définitif ?',
  name: 'socialSecurity',
  validators: { format: [], submit: mustBeFilled('Ce champ est obligatoire') },
};
